<template>
  <layout :width="1024">
    <div class="main-page">
      <div class="content-wrapper">
        <back-button to="/" />
        <br />
        <br />

        <h2>{{ 'room.mainPage.title' | i18n }}</h2>
        <div v-html="$options.filters.i18n('room.mainPage.description')"></div>

        <info-steps
          :step1="'room.info.step1' | i18n"
          :step2="'room.info.step2' | i18n"
          :step3="'room.info.step3' | i18n"/>
        <br />

        <div>
          <h3>{{ 'room.mainPage.step1.title' | i18n }}</h3>
          <p>{{ 'room.mainPage.step1.description' | i18n }}</p>

          <room-params />
          <br />
        </div>

        <div>
          <h3>{{ 'room.mainPage.step2.title' | i18n }}</h3>
          <p>{{ 'room.mainPage.step2.description' | i18n }}</p>

          <div class="form-group">
            <label for="operation-description">
              {{ 'common.mainPage.operationDescription.label' | i18n }}
            </label>
            <textarea id="operation-description" class="form-control" v-model="description"
                      :placeholder="'common.mainPage.operationDescription.placeholder' | i18n"></textarea>
          </div>

          <h4>Valitse korjaustoimenpide</h4>

          <operation-list
            category="tila"
            :operationTypes="roomTypes"
            :paramsComplete="isComplete"
            @operationTypeChanged="onOperationTypeChanged"
            @operationSelected="onOperationSelected" />
        </div>


        <br />
        <back-button to="/" />
      </div>
    </div>
  </layout>
</template>


<script>
  import Vue from 'vue'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import Layout from './Layout'
  import OperationList from './OperationList'
  import RoomParams from './RoomParams'
  import InfoSteps from './InfoSteps'
  import { roomTypes, defaultRoomType } from '../api/constants'
  import calculationService from "../api/calculationService"
  import productService from '../api/productService'

  export default {
    props: [
      'calculationId'
    ],

    methods: {
      onOperationTypeChanged(operationType) {
        this.$store.commit('roomParams/SET_TYPE', operationType)
      },

      onOperationSelected(operation) {
        calculationService.updateCalculation('room', this.calculationId, {
          params: this.apiParams,
          selectedOperationId: operation.id
        })
          .then(() => this.$router.push('/tila/' + this.calculationId + '/tulos'))
      }
    },

    computed: {
      ...mapGetters('roomParams', [
        'isComplete',
        'apiParams'
      ]),
      description: {
        get() {
          return this.$store.state.roomParams.description
        },
        set(description) {
          return this.$store.commit('roomParams/SET_DESCRIPTION', description)
        }
      },
      roomType: {
        get() {
          return this.$store.state.roomParams.type
        },
        set(type) {
          return this.$store.commit('roomParams/SET_TYPE', type)
        }
      }
    },

    data() {
      return {
        roomTypes: roomTypes,
        calculation: null,
        operations: []
      }
    },

    created () {
      // fetch calculation with calculationId (will be created if it doesn't exist)
      calculationService.getCalculation('room', this.calculationId)
        .then(calculation => {
          // if calculation has saved parameters, load those
          if(calculation.params.saved) {
            this.$store.commit('roomParams/SET_FROM_CALCULATION', calculation)
          }
          else {
            this.$store.commit('roomParams/CLEAR');
          }
        })
    },

    components: {
      Layout,
      OperationList,
      RoomParams,
      InfoSteps
    }
  }
</script>

<style scoped>
  .main-page {
    background-image: url("../assets/layout/brownTexture.jpg");
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RoomMainPage.vue